module.exports = __webpack_public_path__ + "img/Attrape_reves_de_mariage.fc155e7.jpg";